import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { AVAILABLE_COMMUNICATION_BOARD_SECTIONS } from './constants'
import { isContentEmpty } from '@/shared/tools/htmlHelper'
import { selectCommunicationBoardState } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useEffect } from 'react'
import { communicationBoardModuleActions } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardSagas'
import { toIntlLocale } from '@/shared/tools/toIntlLocale'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { useRightPanel } from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/rightPanelContext'
import useModuleNotifications from '@/containers/SubscriptionFormPageNew/Components/shared/RightPanel/useModuleNotifications'

const useCommunicationBoardData = () => {
  const { sections, error, loaded } = useSelector(selectCommunicationBoardState)
  const { country } = useSelector(selectAuthData)
  const { expanded } = useRightPanel()
  const { i18n } = useTranslation()
  const dispatch = useDispatch()

  const filledSections = AVAILABLE_COMMUNICATION_BOARD_SECTIONS.map(sectionKey =>
    sections.find(s => s.section === sectionKey),
  ).filter(sectionData => sectionData && !isContentEmpty(sectionData.content))

  const content = filledSections.map(sectionData => sectionData.content).join('')

  const updateStamps = filledSections.map(sectionData => sectionData.updated_at).filter(Boolean)

  const latestUpdate = updateStamps.map(value => new Date(value)).sort((first, second) => second - first)[0]

  const updatedAt = latestUpdate
    ? {
        date: latestUpdate.toLocaleDateString(toIntlLocale(i18n.language)),
        time: latestUpdate.toLocaleTimeString(toIntlLocale(i18n.language), { hour: '2-digit', minute: '2-digit' }),
      }
    : null

  useModuleNotifications({
    moduleKey: 'communication-board',
    scope: country,
    items: updateStamps,
    loaded,
    visible: expanded,
  })

  useEffect(() => {
    dispatch({
      type: communicationBoardModuleActions.COMMUNICATION_BOARD_MODULE_LOAD_DATA,
    })
  }, [])

  return { content, updatedAt, error, folded: !expanded }
}

export default useCommunicationBoardData
